<template>
    <div class="">
        <div class="d-flex align-items-center justify-content-between">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item"><router-link to="/dashboard">Dashboard</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">Schools</li>
                </ol>
                <label class="form-label"> <h4>Schools</h4></label>
            </div>
            <div class="d-flex">
                <Search
                                class="me-2"
                                :class="{ 'is-invalid': errors?.district_id }"
                                :customClass="{ 'is-invalid': errors?.district_id }"
                                :initialize="meta.district_id"
                                id="district_id"
                                label="district"
                                placeholder="Select District"
                                :data=" all_districts"
                                @input="district => { meta.district_id = district; getPlaces(); search(); }"
                            >
                            </Search>
                            <Search v-if="meta.district_id"
                                class="me-2"
                                :class="{ 'is-invalid': errors?.place }"
                                :customClass="{ 'is-invalid': errors?.place }"
                                :initialize="meta.place"
                                id="place"
                                label="place"
                                placeholder="Select Place"
                                :data=" all_places"
                                @input="place => { meta.place = place; search(); }"
                            >
                            </Search>
                            <button type="button" class="btn d-flex align-item-center btn-danger me-2" @click="reset()">
                    <i class="ri-refresh-line me-1"></i>RESET</button>

                <router-link to="/schools/create" type="submit" class="btn d-flex align-item-center btn-primary me-2">
                    <i class="ri-add-line me-1"></i>
                    ADD SCHOOL
                </router-link>
                <button type="button" data-bs-toggle="modal" data-bs-target="#exampleModal" class="btn d-flex align-item-center btn-success" @click="clearUploadFile">
                    <i class="ri-upload-line me-1"></i>
                    FILE UPLOAD
                </button>
            </div>
        </div>
        <div class="card br-16 card-shadow">
            <div class="card-body">
                <div class="form-group mb-2 d-flex">
                    <input class="form-control form-control-sm" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()" />
                </div>
                <div class="table-responsive table-responsive-sm" style="height: 415px; overflow: scroll;">
                    <table class="table table-sm text-nowrap table-bordered mb-0">
                        <thead>
                            <tr v-if="schools.length == 0">
                                <th>#</th>
                                <th>School Name</th>
                                <th>KG Strength</th>
                                <th>District</th>
                                <th>Place</th>
                                <th>Pin Code</th>
                                <th>Address</th>
                                <th>Board</th>
                                <th>Principal</th>
                                <th>Email</th>
                                <th>Phone Number</th>
                                <th>Web Site</th>
                                <th>Present Stage</th>
                                <th>Next Stage</th>
                                <th>Next Reminder Date</th>
                                <th>Last Updated By</th>
                                <th class="text-center">Status</th>
                                <th class="text-center">Actions</th>
                            </tr>
                            <tr v-else>
                                <th class="text-center sticky-col col-0 sticky">#</th>
                                <th class="sticky-col col-1 sticky" @click="sort('school_name')">
                                    School Name
                                    <span>
                                        <i v-if="meta.keyword == 'school_name' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'school_name' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th class="sticky-col col-2 sticky">
                                    KG Strength
                                </th>
                                <th @click="sort('district')">
                                    District
                                    <span>
                                        <i v-if="meta.keyword == 'district' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'district' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('place')">
                                    Place
                                    <span>
                                        <i v-if="meta.keyword == 'place' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'place' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>

                                <th @click="sort('pincode')">
                                    Pin Code
                                    <span>
                                        <i v-if="meta.keyword == 'pincode' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'pincode' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('address')">
                                    Address
                                    <span>
                                        <i v-if="meta.keyword == 'address' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'address' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('board')">
                                    Board
                                    <span>
                                        <i v-if="meta.keyword == 'board' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'board' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>

                                <th @click="sort('principal')">
                                    Principal
                                    <span>
                                        <i v-if="meta.keyword == 'principal' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'principal' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('email')">
                                    Email
                                    <span>
                                        <i v-if="meta.keyword == 'email' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'email' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('phone_number')">
                                    Phone Number
                                    <span>
                                        <i v-if="meta.keyword == 'phone_number' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'phone_number' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>
                                <th @click="sort('web_site')">
                                    Web Site
                                    <span>
                                        <i v-if="meta.keyword == 'web_site' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                        <i v-else-if="meta.keyword == 'web_site' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                        <i v-else class="fas fa-sort"></i>
                                    </span>
                                </th>

                                <th>Present Stage</th>
                                <th>Next Stage</th>
                                <th>Next Reminder Date</th>
                                <th>Last Updated By</th>
                                <th class="text-center">Status</th>
                                <th class="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="schools.length == 0">
                                <td colspan="18" class="text-center">No records found</td>
                            </tr>
                            <tr v-for="(school, key) in schools" :key="key">
                                <td class="text-center sticky-col col-0 sticky">{{ meta.from + key }}</td>
                                <td class="sticky-col col-1 sticky text-wrap">{{school.school_name}}</td>
                                <td class="sticky-col col-2 sticky">
                                    <span v-for="fields, key in school.SessionFields" :key="key">
                                        <span v-if="fields?.field_name == 'KG Strength'">{{ fields?.value }} </span>
                                    </span>
                                </td>
                                <td>{{ school?.District?.district}}</td>
                                <td>{{ school.place}}</td>
                                <td>{{ school.pincode }}</td>
                                <td>{{ school.address }}</td>

                                <td>{{ school.board }}</td>
                                <td>{{ school.principal }}</td>
                                <td>{{ school.email }}</td>
                                <td>{{ school.phone_number }}</td>
                                <td>{{ school.web_site }}</td>
                                <td>{{ school?.SessionComments[0]?.PresentStage?.stage }}</td>
                                <td>{{ school?.SessionComments[0]?.NextStage?.stage }}</td>
                                <td>{{ changeDateTime(school?.SessionComments[0]?.reminder_date_time) }}</td>
                                <td>{{ school?.SessionComments[0]?.User?.name }}</td>
                                <td class="text-center">
                                    <div class="form-switch form-switch">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            :id="'school' + school.school_id"
                                            :checked="school.deleted_at ? 0 : 1"
                                            :value="school.deleted_at ? 0 : 1"
                                            @change="deleteSchool(school)"
                                        />
                                        <label class="custom-control-label" :for="'school' + school.school_id"></label>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <nav v-if="!school.deleted_at">
                                        <a href="javascript:void(0)" class="text-success me-2" @click.prevent="edit(school)"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                        <a href="javascript:void(0)" class="text-success me-2" data-bs-toggle="modal" data-bs-target="#exampleModal1" @click="view_contact(school)"><i class="ri-map-pin-user-fill fs-18 lh-1"></i></a>
                                        <a v-if="school?.SessionComments[0]?.session_comment_id" href="javascript:void(0)" class="text-secondary me-2" @click.prevent="view(school)"><i class="ri-eye-line fs-18 lh-1"></i></a>
                                        <a v-else href="javascript:void(0)" class="text-secondary me-2" data-bs-toggle="modal" data-bs-target="#exampleModal2" @click.prevent="dynamic_view(school)"><i class="ri-eye-line fs-18 lh-1"></i></a>
                                    </nav>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
         <div class="mt-3">
                <div class="d-flex justify-content-between align-items-center">
                    <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                        <option>10</option>
                        <option>15</option>
                        <option>20</option>
                        <option>25</option>
                        <option>30</option>
                    </select>
                    <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta?.totalRows }} entries</span>
                    <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                </div>
            </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">School Upload</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeUploadModal" @click="clearUploadFile"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="d-flex justify-content-between align-items-center mb-2">
                                <label for="formFile" class="form-label mb-0">Upload File</label>
                                <button type="button" class="btn btn-sm btn-outline-primary" @click="downloadSchoolTemplate">
                                    <i class="ri-download-line me-1"></i>Download Template
                                </button>
                            </div>
                            <input class="form-control" type="file" id="formFile" accept=".csv,.xls,.xlsx" :class="{'is-invalid': errors?.file}" ref="file" @change="onUploadFileChange" />
                            <span v-if="errors?.file" class="invalid-feedback">{{ errors.file }}</span>
                            <div v-if="uploadRowErrors.length" class="alert alert-warning mt-3 mb-0">
                                <p class="mb-2 fw-semibold">The following rows could not be imported:</p>
                                <ul class="mb-0 ps-3">
                                    <li v-for="(rowError, key) in uploadRowErrors" :key="key">{{ rowError }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="clearUploadFile">Close</button>
                    <button type="button" class="btn btn-primary" @click="uploadSchoolData">Upload</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="exampleModal2" tabindex="-1" aria-labelledby="exampleModal2Label" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModal2Label">Additional School Information</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeModal"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <nav class="nav nav-classic">
                                <span v-if="dynamic_data.length > 0" v-for="(session_form, key) in dynamic_data" :key="key" class="nav-link text-dark">
                                    <span style="width: 200px;">{{ session_form.display_name}}</span>
                                    <span class="badge text-dark" style="text-wrap: balance; font-size: 14px;">{{ session_form.value}}</span>
                                </span>
                                <span v-else>
                                    <span class="badge text-dark" style="text-wrap: balance; font-size: 14px;">No additional data is available</span>
                                </span>
                            </nav>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" data-bs-backdrop="static" id="exampleModal1" tabindex="-1" aria-labelledby="exampleModal1Label" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModal1Label">Additional Contact Details</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeModal"></button>
                </div>
                <div class="modal-body">
                    <div class="table-responsive table-responsive-sm">
                        <table class="table table-sm text-nowrap table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th class="text-center">#</th>
                                    <th>Name</th>
                                    <th>Mobile Number</th>
                                    <th>Email Id</th>
                                    <th>Designation</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="SchoolContacts.length == 0">
                                    <td colspan="5" class="text-center">No records found</td>
                                </tr>
                                <tr v-for="(school_contact, key) in SchoolContacts" :key="key">
                                    <td class="text-center">{{ meta.from + key }}</td>
                                    <td>{{ school_contact?.name }}</td>
                                    <td>{{ school_contact?.mobile }}</td>
                                    <td>{{ school_contact?.email}}</td>
                                    <td>{{ school_contact?.designation }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <!-- <button type="button" class="btn btn-primary" @click="submitdistricts()">Save changes</button> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    import MultiSelect from "primevue/multiselect";
import moment from "moment";
import Search from "@/components/Search.vue";
import axios from "axios";
    export default {
        components: { Pagination, MultiSelect,Search },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "school_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                    district_id: '',
                    place:'',
                },
                file: "",
                upload: {
                    file: "",
                },
                uploadRowErrors: [],
                schools: [],
                school: "",
                errors: [],
                SchoolContacts: [],
                dynamic_data: [],
                all_districts: [],
                all_places: [],
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.meta.search = vm.$store.getters.school_search;
                if (from.name == "School.Edit") {
                    vm.meta.page = vm.$store.getters.current_page;
                } else {
                    vm.meta.page = 1;
                }
            });
        },
        mounted() {
            this.index();
            this.getAllDistricts();
        },
        methods: {
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.$store.commit("setSchoolSearch", vm.meta.search);
                vm.index();
            },
            getAllDistricts() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "district/getAllDistricts" })
                    .then((response) => {
                        console.log("distt", response.data.data);
                        loader.hide();
                        vm.all_districts = response.data.data;

                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            getPlaces() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "school/getPlaces", data: { district_id: vm.meta.district_id } })
                    .then((response) => {
                        console.log("distt", response.data.data);
                        loader.hide();
                        vm.all_places = response.data.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            changeDate(date_time) {
                if (date_time) {
                    return moment(date_time).format("DD-MM-YYYY hh:mm:ss A");
                }
                return "";
            },
            changeDateTime(date_time) {
                if (date_time) {
                    return moment.utc(date_time).format("DD-MM-YYYY hh:mm:ss A");
                }
                return "";
            },
            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "school/paginateSchool", data: vm.meta })
                    .then(function (response) {
                        vm.schools = response.data.data.data;
                        vm.meta.totalRows = response.data.data.meta.total;
                        vm.meta.lastPage = response.data.data.meta.lastPage;
                        vm.meta.from = response.data.data.meta.from;
                        const end = vm.meta.from + Number(vm.meta.per_page) - 1;
                        vm.meta.to = end > vm.meta.totalRows ? vm.meta.totalRows : end;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            edit(school) {
                this.$store.commit("setCurrentPage", parseInt(this.meta.page));
                this.$router.push("/schools/" + school.school_id + "/edit");
            },
            dynamic_view(school) {
                this.dynamic_data = school?.SessionFields;
            },
            view_contact(school_contact_data) {
                this.SchoolContacts = school_contact_data.SchoolContacts;
            },
            view(school) {
                this.$router.push("/session_forms/" + school.school_id + "/view");
            },
            reset() {
                let vm = this;
                vm.meta = {
                    search: "",
                    order_by: "asc",
                    keyword: "school_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                    district_id: '',
                    place: '',
                };
                vm.index();
            },
            deleteSchool(school) {
                let vm = this;
                let loader = vm.$loading.show();
                school.status = school.status == 1 ? 0 : 1;
                vm.$store
                    .dispatch("post", { uri: "school/deleteSchool", data: school })
                    .then(function (response) {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.index();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.error;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
            clearUploadFileError() {
                if (!this.errors?.file) {
                    return;
                }
                const next = { ...this.errors };
                delete next.file;
                this.errors = next;
            },
            clearUploadRowErrors() {
                this.uploadRowErrors = [];
            },
            onUploadFileChange() {
                if (this.$refs.file?.files?.length) {
                    this.clearUploadFileError();
                    this.clearUploadRowErrors();
                }
            },
            clearUploadFile() {
                if (this.$refs.file) {
                    this.$refs.file.value = "";
                }
                this.clearUploadFileError();
                this.clearUploadRowErrors();
            },
            async downloadSchoolTemplate() {
                try {
                    const response = await axios({
                        url: this.$store.getters.apiUrl + "api/school/downloadSchoolUploadTemplate",
                        method: "POST",
                        responseType: "blob",
                        headers: {
                            Authorization: "Bearer " + this.$store.getters.token,
                        },
                    });

                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "school_upload_template.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                } catch (error) {
                    console.error("Error downloading school template:", error);
                    this.$store.dispatch("error", "Failed to download school upload template.");
                }
            },
            uploadSchoolData() {
                let vm = this;
                const file = vm.$refs.file?.files?.[0];
                if (!file) {
                    vm.errors = {
                        ...(Array.isArray(vm.errors) ? {} : vm.errors),
                        file: "Please select a file to upload.",
                    };
                    return;
                }
                let loader = vm.$loading.show();
                let data = new FormData();
                data.append("file", file);
                vm.$store
                    .dispatch("post", { uri: "school/schoolUpload", data: data })
                    .then(function (response) {
                        loader.hide();
                        const rowErrors = response.data?.data?.row_errors || [];
                        vm.uploadRowErrors = rowErrors;

                        if (rowErrors.length) {
                            vm.$store.dispatch("error", response.data.message);
                            vm.index();
                            return;
                        }

                        vm.$store.dispatch("success", response.data.message);
                        vm.errors = [];
                        vm.clearUploadFile();
                        document.getElementById("closeUploadModal").click();
                        vm.index();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response?.data?.errors || {};
                        vm.uploadRowErrors = vm.errors?.row_errors || [];
                        let message = error.response?.data?.message || "Upload failed.";
                        if (vm.errors?.missing_columns) {
                            message += ` Missing columns: ${vm.errors.missing_columns}.`;
                        }
                        vm.$store.dispatch("error", message);
                    });
            },
        },
    };
</script>

<style scoped>
    /* .sticky-col {
        position: -webkit-sticky;
        position: sticky;
        background-color: #fff;
        z-index: 3;
        border-right: 1px solid #dee2e6;
    }

    .col-1 {
        left: 0;
        width: 50px;
    }

    .col-2 {
        left: 30px;
        background-color: #fff;
        min-width: 290px;
    }

    .col-3 {
        left: calc(50px + 270px);
        width: 100px;
    }

    .table {
        table-layout: auto;
        width: 100%;
    }

    .table-responsive {
        overflow-x: auto;
    } */

    .sticky {
        position: sticky;
        left: 0;
        background-color: #fff; /* Optional: Adds a white background for better visibility */
        z-index: 1; /* Ensures the sticky columns stay above other columns */
    }

    /* Optional: Apply a background color for the header cells */
    .sticky-col {
        background-color: #f8f9fa; /* Light grey background */
    }

    /* Fix the sticky columns on scroll */
    .sticky-col.col-0 {
        left: 0;
        z-index: 2; /* Higher index for the first column */
    }

    .sticky-col.col-1 {
        left: 25px;
        z-index: 2;
    }
    .sticky-col.col-2 {
        left: 268px;
        z-index: 2;
    }

    /* .sticky-col.col-1 {
        left: 189px;
        z-index: 2;
        max-width: 445px;
    } */

    /* .sticky-col.col-2 {
        left: 575px;
        z-index: 2;
    } */

    table th,
    table td {
        padding: 6px 10px;
        /* border: 1px solid #dee2e6;  */
    }
    .text-wrap {
        /* word-wrap: break-word; */
        /* word-break: break-word; */
        /* white-space: normal; */
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        /* overflow: hidden; */
        /* text-overflow: ellipsis; */
        width: 250px; /* Adjust width to fit your layout */
    }
</style>
